import { usePermissions } from 'shared'
import { useGridApiRef } from '../../gridApi'
import { mapContextMenuItems } from '../helpers/context-menu.helpers'

export const useContextMenu = ({
  instanceName,
  columnDefs,
  iGetContextMenuItems,
  iEnableRowSelection,
  setConfirmationConfig,
}) => {
  const permissions = usePermissions()

  const gridApiRef = useGridApiRef(instanceName)

  const getContextMenuItems = (gridProp, ...args) => {
    if (!iGetContextMenuItems || gridProp.node === null) {
      return null
    }

    if (iEnableRowSelection) {
      gridProp.node.setSelected(true, true)
    }

    const items = iGetContextMenuItems(gridProp, ...args)
    const rowData = gridProp.node.data
    const { api } = gridApiRef.current

    return mapContextMenuItems(items, { columnDefs, rowData, api, permissions, setConfirmationConfig })
  }

  return getContextMenuItems
}
